<template>
  <div id="bbsContainer">
    <header class="app-header" v-if="this.$route.path != '/bbs/create'">
      <div class="header-container">
        <div class="header-left">
          <h1 class="logo">
            <!-- <span class="logo-icon">💎 </span> -->
            <img alt="logoimg" src="@/assets/sys_logo.png" width="36" @click="$router.push('/')">
            <span class="logo-text" @click="$router.push('/bbs')">统计人社区</span>
          </h1>
          <nav class="main-nav">
            <router-link to="/" class="nav-item" exact>首页</router-link>

            <router-link to="/bbs/index" class="nav-item">话题</router-link>
            <!-- <a href="#" class="nav-item">
              菜单一
              <el-badge value="NEW" class="badge-new" />
            </a> -->
            <!-- <router-link to="/bbs/index?category=FAQ" class="nav-item" exact>问答</router-link> -->


            <a href="#" class="nav-item">帮助中心</a>
            <!-- <a href="#" class="nav-item">菜单四</a> -->
          </nav>
        </div>

        <div class="header-center">
          <el-input v-model="searchKeyword" placeholder="输入你想查找的内容" @keyup.enter.native="handleSearch"
            class="search-input">
            <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            <i slot="suffix" class="el-input__icon el-icon-search"></i>

          </el-input>
        </div>

        <div class="header-right">
          <!-- <el-button size="small" class="creator-btn">创作者中心</el-button>
          <el-button size="small" type="text" class="member-btn">会员</el-button>
          <el-badge :value="13" class="notification-badge">
            <el-button size="small" type="text" icon="el-icon-bell" circle></el-button>
          </el-badge> -->
          <user-nav color="blue" ref="userNav"></user-nav>
          <!-- <el-button type="primary" icon="el-icon-edit" circle size="small" @click="handCreate"></el-button> -->
        </div>
      </div>
    </header>

    <main class="app-main">
      <router-view></router-view>
    </main>

    <!-- <footer class="app-footer">
      <div class="container">
        <p>&copy; 2025 报表智能体. All rights reserved.</p>
      </div>
    </footer> -->
  </div>
</template>

<script>
import userNav from "@/components/userNav"
import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";
export default {
  name: 'App',
  data() {
    return {
      searchKeyword: ''
    };
  },
  components: {

    userNav
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.login.userInfo,
      token: (state) => state.login.token,
    }),
  },
  async created() {
    console.log(this.$route);

    if (this.token) {
      this.routerView = false;

      await this.getUserInfo();

      this.routerView = true;
    }

  },
  methods: {
    ...mapActions(["getUserInfo"]),

    async handCreate() {
      if (this.userInfo) {
        this.$router.push({
          name: "CreatePost",
        });
      } else {
        // this.$refs.userNav.openLoginDialog()
        if (!this.$store.getters.isLoggedIn) {
          const result = await this.$login()
          console.log('登录返回结果:', result)
          return
        }

      }
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        this.$router.push({
          path: '/bbs',
          query: { ...this.$route.query, search: this.searchKeyword.trim() }

        });
        // this.searchKeyword = '';
      }
    }
  }
};
</script>

<style scoped lang="scss">
$panel-radius: 34px;
$sidebar-width: 280px;
$info-width: 300px;
$app-bg-start: #f5f8ff;
$app-bg-end: #fef6fb;
$primary-color: #5d5fef;
$secondary-color: #898bff;
$text-color: #1f2346;
$muted-color: #8f94b2;
$border-color: rgba(143, 148, 178, 0.2);
$card-bg: #ffffff;
$card-shadow: 0 20px 60px rgba(99, 119, 255, 0.1);

#bbsContainer {
  background-image: linear-gradient(135deg, #ecf3fe 0%, #fff2ff 10%, #f5f8ff 20%, #ecf3fe 30%, #ffe3ff 40%, #fef6fb 100%);
}

.app-header {
  color: #1d2129;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  // box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  // border-bottom: 1px solid #e5e6eb;
}

.header-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  background: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);

}

.header-left {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 0 0 auto;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1d2129;
  cursor: pointer;
  margin: 0;
  white-space: nowrap;
}

.logo-icon {
  font-size: 1.5rem;
}

.logo-text {
  // background: linear-gradient(135deg, #007fff 0%, #0066cc 100%);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
  // background-clip: text;
}

.main-nav {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.nav-item {
  color: #4e5969;
  text-decoration: none;
  padding: 0.5rem 1rem;
  // border-radius: 4px;
  transition: all 0.2s;
  font-size: 0.875rem;
  position: relative;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  height: 60px;
}

.nav-item:hover {
  background: #f2f3f5;
  color: #1d2129;
}

.nav-item.router-link-active {
  border-bottom: 2px solid #007fff;
  background: transparent;
}

.badge-new {
  margin-left: 0.25rem;
}

.badge-new>>>.el-badge__content {
  background-color: #ff4757;
  border: none;
  font-size: 0.625rem;
  padding: 0 0.25rem;
  height: 16px;
  line-height: 16px;
}

.header-center {
  flex: 1;
  max-width: 400px;
  margin: 0 2rem;
}

::v-deep .search-input .el-input__inner {
  border-radius: 10px;
  background: #f7f8fa;
  border: 1px solid transparent;
}

::v-deep .search-input .el-input__inner:focus {
  border-color: #007fff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 0 0 auto;
}

.creator-btn {
  border-color: #e5e6eb;
  color: #4e5969;
}

.creator-btn:hover {
  border-color: #d9dce0;
  background: #f2f3f5;
}

.member-btn {
  color: #4e5969;
}

.notification-badge>>>.el-badge__content {
  background-color: #ff4757;
  border: none;
}

.app-main {
  min-height: calc(100vh - 0px);
  // background: #f7f8fa;
}

.app-footer {
  background: white;
  border-top: 1px solid #e5e6eb;
  padding: 2rem 0;
  text-align: center;
  color: #86909c;
  font-size: 0.875rem;
  margin-top: 3rem;
}

@media (max-width: 1200px) {
  .main-nav {
    display: none;
  }

  .header-center {
    max-width: 300px;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 1rem;
  }

  .header-center {
    display: none;
  }

  .creator-btn,
  .member-btn {
    display: none;
  }
}
</style>
